import React, { useState } from 'react'
import useTheme from 'hooks/useTheme'
import { Flex, Card } from '@nominex/dex-uikit'
import { useSelector } from 'react-redux'
import { AppState } from 'state'
import { FetchStatus } from 'state/types'
import { SlPopup } from '@shoelace-style/shoelace/dist/react'
import DropdownTrigger from './DropdownTrigger'
import RewardsCardBody, { RewardsCardBodyProps } from './RewardsCardBody'
import RewardsCardFooter, { RewardsCardFooterProps } from './RewardsCardFooter'
import { Overlay } from './styles'

const ExtraRewardsDropdown: React.FC = ({ ...props }) => {
  const { theme } = useTheme()
  const [active, setActive] = useState(false)

  const {
    fetchStatus: bonusesFetchStatus,
    cashback,
    holderBonus,
    referralFarming,
    referralTrading,
    teamFarming,
    teamTrading,
    total,
  } = useSelector((state: AppState) => state.affiliate.user.bonuses)
  const { fetchStatus: nextRewardFetchStatus, total: nextReward } = useSelector(
    (state: AppState) => state.affiliate.user.bonuses.nextReward,
  )

  const referralRewards = referralFarming + referralTrading + teamFarming + teamTrading

  const rewardsCardBodyProps: RewardsCardBodyProps = {
    fetchStatus: bonusesFetchStatus,
    cashback,
    holderBonus,
    referralRewards,
  }
  const rewardsCardFooterProps: RewardsCardFooterProps = {
    nextReward,
    total,
    bonusesFetchStatus,
    nextRewardFetchStatus,
  }

  return (
    <>
      {active ? <Overlay /> : null}
      <SlPopup
        placement="bottom"
        active={active}
        onMouseOver={() => setActive(true)}
        onMouseOut={() => setActive(false)}
      >
        <DropdownTrigger
          slot="anchor"
          nmxReward={total}
          isLoaded={bonusesFetchStatus !== FetchStatus.FETCHED}
          {...props}
        />
        {active && (
          <Card borderBackground={theme.colors.gradients.purple} minWidth="376px" mt="10px" {...props}>
            <Flex className="py-16 px-16 rounded-t-12 bg-dark-gray-700">
              <RewardsCardBody {...rewardsCardBodyProps} />
            </Flex>
            <Flex className="py-16 px-16 rounded-b-12 bg-dark-gray-600">
              <RewardsCardFooter {...rewardsCardFooterProps} />
            </Flex>
          </Card>
        )}
      </SlPopup>
    </>
  )
}

export default ExtraRewardsDropdown
